module.exports = __webpack_public_path__ + "static/media/Future Forests.55c338a3.mp4";